import { render } from "./AccountApiSettings.vue?vue&type=template&id=608badb0"
import script from "./AccountApiSettings.vue?vue&type=script&lang=js"
export * from "./AccountApiSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__